import React from "react";

export const LinkPreviewCard = ({ preview }: any) => {
  if (!preview) return null;

  return (

    <div
      className="p-2 rounded bg-light"
      style={{ maxWidth: 320 }}
    >
      <a
        href={preview.url}
        target="_blank"
        rel="noopener noreferrer"
        className="d-block text-decoration-none"
        style={{ color: "inherit" }}
      >
        {/* 📷 Imagem */}
        {preview.image && (
          <div
            style={{
              width: "100%",
              height: "100%",
              background: "#f2f2f2",
              borderRadius: 8,
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={preview.image}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>
        )}

        {/* 📝 Descrição com ellipsis */}
        <div
          className="fw-bold text-muted small mt-2"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "pre-line",
            minHeight: 45,
          }}
        >
          {preview.desc}
        </div>
      </a>

      {/* 🔗 Botão "Abrir Link" visual */}
      <a
        href={preview.url}
        target="_blank"
        rel="noopener noreferrer"
        className="d-flex align-items-center justify-content-center gap-2 mt-2 py-2 px-3 rounded"
        style={{
          background: "#e7f1ff",
          border: "1px solid #c7dcff",
          color: "#0d6efd",
          fontWeight: 500,
          textDecoration: "none",
        }}
      >
        <i className="bx bx-link-external"></i>
        Abrir Link
      </a>
    </div>


    // <div
    //   className="p-2 rounded bg-light"
    //   style={{ maxWidth: 320 }}
    // >
    //   <a
    //     href={preview.url}
    //     target="_blank"
    //     rel="noopener noreferrer"
    //     className="d-block text-decoration-none"
    //   >
    //     {/* 🖼️ Container da imagem */}
    //     {preview.image && (
    //       <div
    //         style={{
    //           width: "100%",
    //           maxHeight: "70%",
    //           background: "#f8f9fa",
    //           borderRadius: 8,
    //           overflow: "hidden",
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "center",
    //           objectFit: "contain",  // ⬅️ impede corte
    //         }}
    //       // style={{
    //       //   width: "100%",
    //       //   height: "100%",
    //       //   objectFit: "contain",  // ⬅️ impede corte
    //       // }}

    //       >
    //         <img
    //           src={preview.image}
    //           alt=""
    //           className="img-fluid rounded mb-2"
    //           style={{
    //             width: "100%",
    //             height: "100%",
    //             objectFit: "contain",  // ⬅️ impede corte
    //           }}
    //         />
    //       </div>
    //     )}

    //     {/* 📝 Descrição */}
    //     <div
    //       className="fw-bold text-muted small mt-2"
    //       style={{
    //         display: "-webkit-box",
    //         WebkitLineClamp: 3,
    //         WebkitBoxOrient: "vertical",
    //         overflow: "hidden",
    //         textOverflow: "ellipsis",
    //         whiteSpace: "pre-line",
    //       }}
    //     >
    //       {preview.desc}
    //     </div>

    //     {/* 🔗 URL */}
    //     {/* <div
    //       className="text-primary small mt-1 text-break"
    //       style={{ wordBreak: "break-all" }}
    //     >
    //       {preview.url}
    //     </div> */}
    //   </a>
    // </div>


  );
};
